export const PassportUserTypes = {
    USER_TYPE_ADMIN : 1,
    USER_TYPE_CHILD : 2,
    USER_TYPE_TEACHER : 3,
    USER_TYPE_SCHOOL_MANAGER : 4,
    USER_TYPE_TRAINING_ADMIN : 5,
    USER_TYPE_PROSPECTIVE : 6,
    USER_TYPE_TRAINING_FACILITATOR: 7,
    USER_TYPE_EXTERNAL_PRACTITIONER: 8,
    USER_TYPE_EHCP_MANAGER: 9,
    USER_TYPE_EHCP_ADMIN: 10,
    USER_TYPE_EHCP_LEARNER: 11,
    USER_TYPE_EHCP_COORDINATOR: 12,
    USER_TYPE_EHCP_GUEST: 13,
    USER_TYPE_PASSPORT_GUEST: 14,
}
